"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TalentPoolsContract = void 0;
/* eslint-disable perfectionist/sort-objects */
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../schemas");
const talent_pools_request_1 = require("./talent-pools.request");
const talent_pools_response_1 = require("./talent-pools.response");
const c = (0, core_1.initContract)();
exports.TalentPoolsContract = c.router({
    create: {
        method: 'POST',
        path: '/',
        body: talent_pools_request_1.CreateTalentPoolRequestSchema,
        responses: {
            201: talent_pools_response_1.TalentPoolResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
    update: {
        method: 'PATCH',
        path: '/:poolId',
        body: talent_pools_request_1.UpdateTalentPoolRequestSchema,
        pathParams: talent_pools_request_1.TalentPoolIdPathParamsSchema,
        responses: {
            200: talent_pools_response_1.TalentPoolResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    delete: {
        method: 'DELETE',
        path: '/:poolId',
        pathParams: talent_pools_request_1.TalentPoolIdPathParamsSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    findMany: {
        method: 'GET',
        path: '/',
        query: talent_pools_request_1.TalentPoolQuerySchema,
        responses: {
            200: talent_pools_response_1.TalentPoolListResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
    findById: {
        method: 'GET',
        path: '/:poolId',
        pathParams: talent_pools_request_1.TalentPoolIdPathParamsSchema,
        query: talent_pools_request_1.TalentPoolMembers,
        responses: {
            200: talent_pools_response_1.TalentPoolResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    addCandidate: {
        method: 'PUT',
        path: '/:poolId/candidates/:candidateId',
        body: schemas_1.EmptyBodySchema,
        pathParams: talent_pools_request_1.TalentPoolCandidatePathParamsSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    removeCandidate: {
        method: 'DELETE',
        path: '/:poolId/candidates/:candidateId',
        pathParams: talent_pools_request_1.TalentPoolCandidatePathParamsSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
}, { pathPrefix: '/talent-pools' });
